<template>
  <section :class="[sectionClass, !style_2 && 'feature-strip']">
    <div :class="containerClass">
      <div :class="listClass">
        <div
          class="row row-cols-xxl-4 row-cols-xl-4 row-cols-lg-4 row-cols-md-2 row-cols-sm-2 row-cols-1"
          :class="style_2 ? 'gx-0' : 'g-3 g-lg-4 feature-strip__row'"
        >
          <div v-for="feature in featureData" :key="feature.id" class="col">
            <div :class="itemClass">
              <div :class="iconClass">
                <i :class="feature.icon" aria-hidden="true" />
              </div>
              <div :class="contentClass">
                <h6>{{ feature.title }}</h6>
                <p>{{ feature.subtitle }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeatureSection',
  props: {
    style_2: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      featureData: [
        { id: 1, icon: 'fas fa-truck', title: 'FREE DELIVERY', subtitle: 'For all orders over LKR 12,000' },
        { id: 2, icon: 'fas fa-credit-card', title: 'SAFE PAYMENT', subtitle: '100% secure payment' },
        { id: 3, icon: 'fas fa-headset', title: '24/7 HELP CENTER', subtitle: 'Dedicated 24/7 support' },
        { id: 4, icon: 'fas fa-award', title: 'FRIENDLY SERVICES', subtitle: '30 day satisfaction guarantee' }
      ]
    };
  },
  computed: {
    sectionClass() {
      return this.style_2 ? 'features-2__area d-ddark-bg' : 'features__area pt-20';
    },
    containerClass() {
      return `container ${this.style_2 ? 'custom-container' : ''}`;
    },
    listClass() {
      return this.style_2 ? 'features-2__lists pt-25 pb-25' : '';
    },
    itemClass() {
      return this.style_2 ? 'features-2__item' : 'features__item d-flex white-bg';
    },
    iconClass() {
      return this.style_2 ? 'features-2__icon' : 'features__icon mr-20';
    },
    contentClass() {
      return this.style_2 ? 'features-2__content' : 'features__content';
    }
  }
};
</script>

<style scoped>
/* Default home: roomier card grid, large icons, more readable text */
.feature-strip {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 55%);
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  padding-top: 3.5rem !important;
  padding-bottom: 3.75rem !important;
}

.feature-strip :deep(.feature-strip__row) {
  --bs-gutter-x: 1.75rem;
  --bs-gutter-y: 1.75rem;
}

.feature-strip :deep(.features__item) {
  position: relative;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
  padding: 2.4rem 2rem !important;
  height: 100%;
  min-height: 188px;
  border-radius: 18px;
  background: #fff !important;
  border: 1px solid #e8ecf1 !important;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.25s ease, transform 0.2s ease, border-color 0.2s ease;
}

.feature-strip :deep(.features__item::after) {
  display: none !important;
}

.feature-strip :deep(.features__item:hover) {
  border-color: var(--fe-accent, #fcbe00) !important;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.12), 0 6px 16px rgba(15, 23, 42, 0.06),
    0 0 0 1px var(--fe-accent-soft, rgba(252, 190, 0, 0.25));
  transform: translateY(-5px);
}

.feature-strip :deep(.features__icon) {
  flex-shrink: 0;
  margin-right: 0 !important;
  width: 88px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: var(--fe-accent-soft, rgba(252, 190, 0, 0.18));
  transition: background 0.25s ease, transform 0.25s ease;
}

.feature-strip :deep(.features__item:hover .features__icon) {
  background: var(--fe-accent, #fcbe00);
  transform: scale(1.05);
}

.feature-strip :deep(.features__icon i) {
  font-size: 42px !important;
  line-height: 1;
  color: var(--fe-accent, #fcbe00) !important;
  transition: color 0.25s ease;
}

.feature-strip :deep(.features__item:hover .features__icon i) {
  color: #ffffff !important;
}

.feature-strip :deep(.features__content) {
  flex: 1;
  min-width: 0;
}

.feature-strip :deep(.features__content h6) {
  font-size: 18px !important;
  font-weight: 800 !important;
  letter-spacing: 0.05em;
  line-height: 1.25 !important;
  margin-bottom: 0.7rem !important;
  color: var(--fe-text-on-light, #0f172a) !important;
  text-transform: uppercase;
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.feature-strip :deep(.features__content p) {
  font-size: 16px !important;
  line-height: 1.55 !important;
  color: #334155 !important;
  margin-bottom: 0 !important;
  font-weight: 500;
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
  letter-spacing: 0.005em;
}

@media (max-width: 1199px) {
  .feature-strip :deep(.features__item) {
    min-height: 168px;
    padding: 2rem 1.6rem !important;
  }
  .feature-strip :deep(.features__icon) {
    width: 76px;
    height: 76px;
  }
  .feature-strip :deep(.features__icon i) {
    font-size: 36px !important;
  }
  .feature-strip :deep(.features__content h6) {
    font-size: 16px !important;
  }
  .feature-strip :deep(.features__content p) {
    font-size: 15px !important;
  }
}

@media (max-width: 991px) {
  .feature-strip :deep(.features__item) {
    min-height: 150px;
    padding: 1.6rem 1.5rem !important;
  }
  .feature-strip :deep(.features__icon) {
    width: 68px;
    height: 68px;
  }
  .feature-strip :deep(.features__icon i) {
    font-size: 30px !important;
  }
}

@media (max-width: 575px) {
  .feature-strip :deep(.features__item) {
    min-height: 0;
  }
}
</style>